/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Days_Per_Week_5Inputs */

const en_us2_onboarding_days_per_week_5 = /** @type {(inputs: Onboarding_Days_Per_Week_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 days a week`)
};

const pt_br2_onboarding_days_per_week_5 = /** @type {(inputs: Onboarding_Days_Per_Week_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 dias por semana`)
};

const es_419_onboarding_days_per_week_5 = /** @type {(inputs: Onboarding_Days_Per_Week_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 días por semana`)
};

const pt_pt2_onboarding_days_per_week_5 = /** @type {(inputs: Onboarding_Days_Per_Week_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 dias por semana`)
};

const fr_fr2_onboarding_days_per_week_5 = /** @type {(inputs: Onboarding_Days_Per_Week_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 jours par semaine`)
};

const de_de2_onboarding_days_per_week_5 = /** @type {(inputs: Onboarding_Days_Per_Week_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 Tage pro Woche`)
};

const it_it2_onboarding_days_per_week_5 = /** @type {(inputs: Onboarding_Days_Per_Week_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 giorni a settimana`)
};

/**
* | output |
* | --- |
* | "5 days a week" |
*
* @param {Onboarding_Days_Per_Week_5Inputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_days_per_week_5 = /** @type {((inputs?: Onboarding_Days_Per_Week_5Inputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Days_Per_Week_5Inputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_days_per_week_5(inputs)
	if (locale === "es-419") return es_419_onboarding_days_per_week_5(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_days_per_week_5(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_days_per_week_5(inputs)
	if (locale === "de-DE") return de_de2_onboarding_days_per_week_5(inputs)
	if (locale === "it-IT") return it_it2_onboarding_days_per_week_5(inputs)
	return en_us2_onboarding_days_per_week_5(inputs)
});
export { onboarding_days_per_week_5 as "onboarding.days_per_week.5" }